import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { useSearchParams } from 'react-router-dom';

import { AspirationsToday } from '@/types.gql';
import { formatDateWithPattern } from '@/utils';

import { useAspirationContext } from '../hooks/useAspirationContext';

type Props = {
  data: AspirationsToday;
  context: {
    setShowForm: (show: boolean) => void;
  };
};
export function AspirationSelectButton({ data, context }: Props) {
  const { setSelectedAspiration, qcDataSubmitted } = useAspirationContext();
  const [params, setParams] = useSearchParams();

  const opuDate =
    params.get('d') || formatDateWithPattern(new Date(), 'MM-dd-yyyy');
  const opuSiteId = params.get('sId');
  const opuTechnicianId = params.get('otId');

  const handleClick = () => {
    setSelectedAspiration(data);
    if (data) {
      const newParams = new URLSearchParams(params);
      newParams.set('aId', data.aspirationId as string);
      setParams(newParams);
      context.setShowForm(true);
    }
  };

  return (
    <>
      {!qcDataSubmitted && (
        <Tooltip target=".aspiration-select-button-wrapper" />
      )}
      <div
        className="aspiration-select-button-wrapper"
        data-pr-tooltip="Must submit QC data before selecting"
      >
        <Button
          size="small"
          label="Select"
          className="aspiration-select-button"
          onClick={handleClick}
          disabled={
            !opuDate || !opuSiteId || !opuTechnicianId || !qcDataSubmitted
          }
        />
      </div>
    </>
  );
}
